<script>

import { Doughnut } from 'vue-chartjs'

export default {
  extends: Doughnut,

  data: () => ({
      datacollection: {
        labels: ['Progress', 'Done'],
        datasets: [
          {
            backgroundColor: ["#20A39E", "#fff"],
            borderWidth:[0,0]
          }
        ]
      },
    options: {
      legend: { display: false },
      responsive: true,
      maintainAspectRatio: false,
      showTooltips: false,
      cutoutPercentage:0,
      animationEasing: 'easeOutQuart',
      animateScale: false,
      
    }
  }),
  watch: {
  chartData () {
    this.datacollection.datasets[0].data = this.chartData;
    this.$data._chart.update();
  }},
  mounted () {
    this.datacollection.datasets[0].data = this.chartData;
    this.options.cutoutPercentage = this.cutOut;

    this.renderChart(this.datacollection, this.options)

  },
  props: ["chartData", "cutOut"]
}
</script>






